module.exports = __webpack_public_path__ + "fonts/NeutraTextBoldAlt.f9ceaa41.otf";